<template>
  <the-dialog-box
    ref="dialogBox"
    :submit="submit"
    :submit-btn-text="item.id ? 'Update' : 'Create'"
    :max-width="600"
  >
    <template slot="header">
      <span>{{ item.id ? 'Update' : 'Create' }} Project</span>
    </template>
    <template slot="body">
      <v-row>
        <!-- <v-col
          class="pb-0"
          cols="4"
        >
          <inventory-class-select-element
            v-model="item.inventory_class_id"
            :is-add-all="false"
            :auto-select-first="false"
          />
        </v-col> -->
        <v-col
          cols="8"
          class="pb-0"
        >
          <v-text-field
            v-model="item.name"
            :rules="[(v) => !!v || `Project Name is required`, (v) => !!v && v.length <= 45 || 'Max 45 characters']"
            counter="45"
          >
            <template slot="label">
              Project Name<RedAsterisk />
            </template>
          </v-text-field>
        </v-col>
        <v-col
          class="pb-0"
          cols="4"
        >
          <v-text-field
            v-model="item.floor_count"
            type="number"
            min="0"
            :rules="[(v) => !!v || `Number Of Floors is required`]"
          >
            <template slot="label">
              Number Of Floors<RedAsterisk />
            </template>
          </v-text-field>
        </v-col>
      </v-row>
      <!-- <v-row v-if="selectAddressFromClients"> -->
      <v-row>
        <v-col
          cols="12"
          class="pb-0 pt-0"
        >
          <v-autocomplete
            v-model="item.client_id"
            :items="clients"
            item-text="name"
            item-value="id"
            :rules="[(v) => !!v || 'Client is required']"
            :loading="loadClients"
            autocomplete="preventAutocomplete"
          >
            <template slot="label">
              Client<RedAsterisk />
            </template>
          </v-autocomplete>
        </v-col>
        <v-col
          v-if="selectAddressFromClients"
          cols="12"
          class="pb-0 pt-0"
        >
          <v-autocomplete
            v-model="item.client_address_id"
            :items="addresses"
            item-text="address"
            item-value="id"
            no-data-text="Select a Client first"
            :rules="[(v) => !!v || 'Client Address is required']"
            :loading="loadAddresses"
            autocomplete="preventAutocomplete"
          >
            <!-- eslint-disable-next-line vue/no-template-shadow -->
            <template #selection="{ item }">
              <v-chip
                v-if="item && item.type"
                small
                :color="item.type.color"
                text-color="white"
                class="mr-2"
              >
                {{ item.type.name }}
              </v-chip>
              <span>
                {{ item.address }}
              </span>
            </template>
            <!-- eslint-disable-next-line vue/no-template-shadow -->
            <template #item="{ item }">
              <v-chip
                v-if="item && item.type"
                small
                :color="item.type.color"
                text-color="white"
                class="mr-2"
              >
                {{ item.type.name }}
              </v-chip>
              <span>
                {{ item.address }}
              </span>
            </template>
            <template slot="label">
              Address<RedAsterisk />
            </template>
          </v-autocomplete>
        </v-col>
        <v-col
          v-else
          cols="12"
          class="pb-0 pt-0"
        >
          <vuetify-google-autocomplete
            id="google"
            ref="google"
            v-model="item.manual_address"
            :rules="[(v) => !!v || 'Address is required']"
            classname="form-control"
            :country="'ca'"
            @placechanged="getAddressData"
          >
            <template slot="label">
              Address<RedAsterisk />
            </template>
          </vuetify-google-autocomplete>
        </v-col>
      </v-row>
      <confirm-form ref="confirmForm" />
    </template>
  </the-dialog-box>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';

export default {
  components: {
    VuetifyGoogleAutocomplete,
  },
  props: {

  },
  data: () => ({
    item: null,
    itemDto: {
      id: 0,
      name: null,
      client_id: null,
      client_address_id: null,
      manual_address: null,
      floor_count: null,
    },

    clients: [],
    addresses: [],

    loadClients: false,
    loadAddresses: false,
    selectAddressFromClients: false,
  }),
  computed: {
    ...mapState({

    }),
    ...mapGetters([

    ]),
  },
  watch: {
    // eslint-disable-next-line func-names
    'item.client_id': function () {
      if (!this.item.client_id) return;
      this.getAddresses();
    },
  },
  created() {
    this.item = { ...this.itemDto };
  },
  methods: {

    async get(id) {
      if (!id) return;
      const submitModel = {
        filters: {
          id,
        },
      };
      const res = await this.$api.project.read(submitModel);
      if (!res || !res.data || !res.data[0]) return;
      const firstIndex = 0;
      this.item = res.data[firstIndex];

      this.selectAddressFromClients = !!this.item.client_address_id;
    },

    async getClients() {
      this.loadClients = true;
      const readModel = {
        // filters:
        // {
        //   inventory_class_id: this.item.inventory_class_id,
        // },
      };
      const res = await this.$api.client.read(readModel);
      this.clients = res.data;
      this.loadClients = false;
    },

    async getAddresses() {
      this.loadAddresses = true;
      const readModel = {
        filters:
        {
          client_id: this.item.client_id,
        },
      };
      const res = await this.$api.address.read(readModel);
      this.addresses = res;
      if (res.length === 1 && this.selectAddressFromClients) {
        this.item.client_address_id = res[0].id;
      }
      this.loadAddresses = false;
    },

    async submit() {
      if (!this.item) return false;
      let res;
      if (this.item.id) {
        res = await this.$api.project.update(this.item);
      } else {
        res = await this.$api.project.store(this.item);
      }

      if (!res) {
        this.$bus.$emit('showError');
        return false;
      }

      const httpStatusCodeConflict = 409;
      const httpStatusCodeNotExtended = 510;
      if (res.status === httpStatusCodeConflict || res.status === httpStatusCodeNotExtended) {
        this.$bus.$emit('showError', res.message);
        return false;
      }

      if (res.warning) {
        const confirm = await this.$refs.confirmForm.open({
          title: `${res.message}\n\n${res.projects.join('\n')}\n\nContinue anyway?`,
        });

        if (!confirm) {
          return false;
        }

        this.item.force_create = true;

        if (this.item.id) {
          res = await this.$api.project.update(this.item);
        } else {
          res = await this.$api.project.store(this.item);
        }

        if (!res) {
          this.$bus.$emit('showError');
          return false;
        }

        if (res.status === httpStatusCodeConflict || res.status === httpStatusCodeNotExtended || res.warning) {
          this.$bus.$emit('showError', res.message);
          return false;
        }
      }

      delete this.item.force_create;

      this.$bus.$emit('showSuccess');
      this.$emit('success');
      return res;
    },

    async open(id) {
      this.$refs.dialogBox.open();
      if (id) {
        // this.item.id = id;
        this.get(id); // need to await otherwise the clients won't be the correct ones
      } else {
        this.selectAddressFromClients = false;
        this.item = { ...this.itemDto };
      }
      this.getClients();
    },

    async getAddressData(addressData, placeData) {
      this.item.address = placeData.formatted_address;
    },
  },
};
</script>

<style scoped>
/deep/#google {
  width: 100%;
}
</style>
